import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const ServicesPage = () => {
  const services = [
    {
      icon: 'ri-printer-line',
      title: 'Dépliants & Brochures',
      description: 'Impression professionnelle de dépliants publicitaires, brochures commerciales et catalogues de produits en haute qualité.',
      features: ['Papier premium', 'Finitions brillantes ou mates', 'Formats personnalisés', 'Livraison rapide']
    },
    {
      icon: 'ri-article-line',
      title: 'Cartes de Visite',
      description: 'Créez une première impression mémorable avec des cartes de visite élégantes et professionnelles.',
      features: ['Design personnalisé', 'Papier haute qualité', 'Finitions spéciales', 'Prix compétitifs']
    },
    {
      icon: 'ri-picture-in-picture-line',
      title: 'Bâches & Banderoles',
      description: 'Impression grand format pour vos événements, publicités extérieures et signalétique professionnelle.',
      features: ['Tous formats disponibles', 'Résistant aux intempéries', 'Couleurs éclatantes', 'Installation possible']
    },
    {
      icon: 'ri-layout-masonry-line',
      title: 'Autocollants',
      description: 'Autocollants personnalisés pour décoration, branding et communication visuelle impactante.',
      features: ['Toutes formes', 'Découpe personnalisée', 'Adhésif durable', 'Petites et grandes séries']
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Impression Textile',
      description: 'Personnalisation de t-shirts, polos, casquettes et vêtements professionnels avec votre logo et design.',
      features: ['Tous textiles', 'Sérigraphie et broderie', 'Couleurs illimitées', 'Échantillons disponibles']
    },
    {
      icon: 'ri-palette-line',
      title: 'Design Graphique',
      description: 'Création de logos, chartes graphiques et supports visuels pour votre identité de marque.',
      features: ['Design créatif', 'Révisions illimitées', 'Fichiers sources inclus', 'Accompagnement personnalisé']
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Branding Entreprise',
      description: 'Solutions complètes de branding corporate pour renforcer votre image professionnelle.',
      features: ['Identité visuelle complète', 'Supports marketing', 'Charte graphique', 'Manuel de marque']
    },
    {
      icon: 'ri-shopping-cart-line',
      title: 'Vente en Ligne',
      description: 'Accompagnement stratégique pour développer votre présence digitale et vos ventes en ligne.',
      features: ['Stratégie marketing', 'Design e-commerce', 'Visibilité digitale', 'Formation incluse']
    },
    {
      icon: 'ri-gift-line',
      title: 'Supports Publicitaires',
      description: 'Création et impression de tous supports publicitaires pour vos campagnes marketing.',
      features: ['Affiches professionnelles', 'Flyers promotionnels', 'Kakémonos et roll-up', 'PLV complète']
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-black via-[#2D3142] to-black opacity-95"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block bg-[#E63946]/20 text-[#E63946] px-6 py-2 rounded-full text-sm font-semibold mb-6">
            NOS SERVICES
          </span>
          <h1 className="text-white text-6xl lg:text-7xl font-black mb-6">
            Solutions d'Impression<br />
            <span className="text-[#E63946]">Professionnelles</span>
          </h1>
          <p className="text-gray-300 text-xl max-w-3xl mx-auto leading-relaxed">
            De l'impression traditionnelle au marketing digital, nous offrons une gamme complète de services pour répondre à tous vos besoins de communication visuelle.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-[#F8F9FA]">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#E63946] to-[#d32f3c] rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${service.icon} text-white text-3xl`}></i>
                </div>
                
                <h3 className="text-black text-2xl font-bold mb-4">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 text-base leading-relaxed mb-6">
                  {service.description}
                </p>
                
                <ul className="space-y-3">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-3">
                      <i className="ri-check-line text-[#E63946] text-lg"></i>
                      <span className="text-gray-700 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>

                <Link
                  to="/commande-devis"
                  className="mt-6 inline-flex items-center gap-2 text-[#E63946] font-bold text-sm hover:gap-4 transition-all duration-300 cursor-pointer"
                >
                  Demander un devis
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-gray-500 text-sm tracking-widest uppercase mb-4 block">NOTRE PROCESSUS</span>
            <h2 className="text-5xl font-bold text-black mb-4">
              Comment Nous Travaillons
            </h2>
            <p className="text-gray-600 text-lg">
              Un processus simple et efficace pour vos projets d'impression
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              {
                step: '01',
                title: 'Consultation',
                description: 'Nous discutons de vos besoins et objectifs',
                icon: 'ri-discuss-line'
              },
              {
                step: '02',
                title: 'Devis Gratuit',
                description: 'Proposition détaillée et tarifs transparents',
                icon: 'ri-file-list-3-line'
              },
              {
                step: '03',
                title: 'Production',
                description: 'Impression de haute qualité avec suivi',
                icon: 'ri-printer-line'
              },
              {
                step: '04',
                title: 'Livraison',
                description: 'Livraison rapide à votre adresse',
                icon: 'ri-truck-line'
              }
            ].map((item, index) => (
              <div key={index} className="text-center group">
                <div className="relative mb-6">
                  <div className="w-24 h-24 mx-auto bg-gradient-to-br from-[#E63946] to-[#d32f3c] rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                    <i className={`${item.icon} text-white text-4xl`}></i>
                  </div>
                  <span className="absolute -top-2 -right-2 bg-black text-white text-xs font-bold px-3 py-1 rounded-full">
                    {item.step}
                  </span>
                </div>
                <h3 className="text-black text-xl font-bold mb-3">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-black via-[#2D3142] to-black">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-white text-5xl font-bold mb-6">
            Prêt à Démarrer Votre Projet ?
          </h2>
          <p className="text-gray-300 text-lg mb-10">
            Contactez-nous dès aujourd'hui pour un devis gratuit et personnalisé
          </p>
          <div className="flex flex-wrap gap-5 justify-center">
            <Link
              to="/commande-devis"
              className="bg-[#E63946] text-white px-10 py-4 rounded-full font-bold text-base shadow-2xl hover:bg-[#d32f3c] transition-all duration-300 hover:scale-105 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Demander un Devis
              <i className="ri-arrow-right-line"></i>
            </Link>
            <a
              href="tel:0779027536"
              className="border-2 border-white text-white px-10 py-4 rounded-full font-bold text-base hover:bg-white hover:text-black transition-all duration-300 whitespace-nowrap cursor-pointer flex items-center gap-2"
            >
              <i className="ri-phone-line"></i>
              Appelez-nous
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;